import createIcon from '../../createIcon';

/**
 * @component @name KeyboardAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMy41SDNDMS45IDMuNSAxIDQuNCAxIDUuNVYxOC41QzEgMTkuNiAxLjkgMjAuNSAzIDIwLjVIMjFDMjIuMSAyMC41IDIzIDE5LjYgMjMgMTguNVY1LjVDMjMgNC40IDIyLjEgMy41IDIxIDMuNVpNNyAxMS41VjEzLjVINVYxMS41SDdaTTUgOS41VjcuNUg3VjkuNUg1Wk0xMSAxMS41VjEzLjVIOVYxMS41SDExWk05IDkuNVY3LjVIMTFWOS41SDlaTTE2IDE1LjVWMTYuNUg4VjE1LjVIMTZaTTE1IDExLjVWMTMuNUgxM1YxMS41SDE1Wk0xMyA5LjVWNy41SDE1VjkuNUgxM1pNMTcgMTMuNVYxMS41SDE5VjEzLjVIMTdaTTE5IDkuNUgxN1Y3LjVIMTlWOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardAlt = createIcon('KeyboardAlt', [
  [
    'path',
    {
      d: 'M21 3.5H3C1.9 3.5 1 4.4 1 5.5V18.5C1 19.6 1.9 20.5 3 20.5H21C22.1 20.5 23 19.6 23 18.5V5.5C23 4.4 22.1 3.5 21 3.5ZM7 11.5V13.5H5V11.5H7ZM5 9.5V7.5H7V9.5H5ZM11 11.5V13.5H9V11.5H11ZM9 9.5V7.5H11V9.5H9ZM16 15.5V16.5H8V15.5H16ZM15 11.5V13.5H13V11.5H15ZM13 9.5V7.5H15V9.5H13ZM17 13.5V11.5H19V13.5H17ZM19 9.5H17V7.5H19V9.5Z',
      key: '10qsgq',
    },
  ],
]);

export default KeyboardAlt;
